module.exports = __webpack_public_path__ + "static/media/logoLight.d923abc7.png";